import React from "react";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import QuestionItem from "./Question";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

export const QuestionList = ({questions, deleteQuestion, editQuestion}) => {
  const [expandedQuestion, setExpandedQuestion] = React.useState(-1);

  return questions && questions.map((q,idx) =>
    <QuestionItem question={q}
                  key={`question-panel-${idx}`}
                  expandedQuestion={expandedQuestion}
                  setExpandedQuestion={setExpandedQuestion}
                  onQuestionDelete={deleteQuestion}
                  onQuestionEdit={editQuestion}
                  deleteIcon={<DeleteForeverOutlinedIcon fontSize="small"
                                                         style={{ fill: "#93A7BE" }}/>}
                  editIcon={<EditOutlinedIcon
                    fontSize="small"
                    style={{ fill: "#93A7BE" }}/>}
    />)
};

export default QuestionList;
